// extracted by mini-css-extract-plugin
module.exports = {"navy100":"#F8FAFE","tablet":"768px","container":"InsuranceDocuments_container__BmJxe","document":"InsuranceDocuments_document__ZAKXl"};